export default {
  setFeed(state, feed) {
    state.feed = feed;
  },
  setCategories(state, categories) {
    state.categories = categories;
  },
  setCourses(state, courses) {
    state.courses = courses;
  },
  setArchives(state, archives) {
    state.archives = archives;
  },
  setLesson(state, lesson) {
    state.lesson = lesson;
  },
  setLessons(state, lessons) {
    state.lessons = lessons;
  },
  setCategoryLessons(state, { lessons, category }) {
    const data = { ...state.categoryLessons };
    data[category] = lessons;
    state.categoryLessons = data;
  },
  setLive(state, live) {
    state.live = live;
  },
  setFeatured(state, featured) {
    state.featured = featured;
  },
  setCourse(state, course) {
    state.course = course;
  },
  setFreebies(state, freebies) {
    state.freebies = freebies;
  },
  setCount(state, count) {
    state.count = count;
  },
  setProduct(state, product) {
    state.product = product;
  },
  setTrail(state, trail) {
    state.trail = trail;
  },
  setTrails(state, trails) {
    state.trails = trails;
  },
  setResource(state, resource) {
    state.resource = resource;
  },
  setMicrolearning(state, microlearning) {
    state.microlearning = microlearning;
  },
  setMicrolearnings(state, microlearnings) {
    state.microlearnings = microlearnings;
  },
  setHomeCategories(state, homeCategories) {
    state.homeCategories = homeCategories;
  }
};
